define('router',[], function() {

	return Backbone.Router.extend({

		routes: {
			"spotlight" : "spotlight",
			"fans" 	 	: "fans",
			"fan-of" 	: "fanof",
			"contact"   : "contact",
			"" 			: "spotlight",
			"*actions"	: "spotlight"
		},

		spotlight: function() {
			Backstage.Events.trigger('slidepanel:close');
			$('[data-section="spotlight"]').removeClass('hidden');
			$('[data-section="fans-section"]').addClass('hidden');
			if(typeof Backstage.View.Navigation == "object") {
				Backstage.View.Navigation.setActive('spotlight');
			}

			// Make sure to show the images
			Backstage.View.Main.showFirstLoadImages(false);
		},

		fans: function() {
			Backstage.Events.trigger('slidepanel:close');
			$('[data-section="spotlight"]').addClass('hidden');
			$('[data-section="fans-section"]').removeClass('hidden');
			Backstage.View.Fans.showSection('fans');
			Backstage.View.Navigation.setActive('fans');
		},

		fanof: function() {
			Backstage.Events.trigger('slidepanel:close');
			$('[data-section="spotlight"]').addClass('hidden');
			$('[data-section="fans-section"]').removeClass('hidden');
			Backstage.View.Fans.showSection('fan-of');
			Backstage.View.Navigation.setActive('fan-of');
		},

		contact: function() {
			// Do nothing, all events based in main.js
			Backstage.Events.trigger('slidepanel:show_contact_form');
		},

	});

});

